import React, { useEffect } from 'react';
import { Button, InputNumber, Switch, Form, Typography, message } from 'antd';
import { usePasswdSetting } from './controllers/passwd_setting_controller';

const { Title } = Typography;

const PasswdSetting = () => {
    const [form] = Form.useForm();

    const onFinish = ({ axiosMode, status }) => {
        message.destroy(); // 清除舊訊息
        if (axiosMode === "get" && status === "success") {
            // message.success("密碼設定資料載入成功");
        } else if (axiosMode === "get" && status === "error") {
            // message.error("密碼設定資料載入失敗");
        } else if (axiosMode === "patch" && status === "success") {
            message.success("密碼設定已成功保存");
        } else if (axiosMode === "patch" && status === "error") {
            message.error("保存密碼設定失敗");
        }
    };

    const {
        PasswdSettingData: data,
        getPasswdSettingData,
        patchPasswdSettingData,
    } = usePasswdSetting({ 
        onFinish 
    });

    // 畫面載入時自動載入一次密碼設定資料
    useEffect(() => {
        getPasswdSettingData()
        .then((response) => {
            const setting = response?.data[0]; // 確保資料結構正確
            if (setting) {
            form.setFieldsValue({
                uppercase: setting.uppercase_english === 1,
                lowercase: setting.lowercase_english === 1,
                numbers: setting.number === 1,
                specialCharacters: setting.special_symbols === 1,
                passwordLength: setting.passwd_length_id,
            });
            }
        })
        .catch(() => {
            message.error("無法載入密碼設定資料");
        });
    }, []);

    // 保存密碼設定
    const handleSave = () => {
        form
        .validateFields()
        .then((values) => {
            const requestData = {
            passwd_setting_id: 1,
            uppercase_english: values.uppercase ? 1 : 0,
            lowercase_english: values.lowercase ? 1 : 0,
            number: values.numbers ? 1 : 0,
            special_symbols: values.specialCharacters ? 1 : 0,
            passwd_length_id: values.passwordLength,
            };
            patchPasswdSettingData(requestData);
            getPasswdSettingData();
        })
        .catch((error) => {
            console.error('Validation Failed:', error);
        });
    };

    return (
        <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        }}
        >
        <div
            style={{
            background: '#fff',
            padding: '24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            width: '400px',
            }}
        >
            <Title level={4} style={{ textAlign: 'center', marginBottom: '24px' }}>
            密碼條件設定
            </Title>
            <Form form={form} layout="vertical">
            <Form.Item
                label="是否要有大寫英文"
                name="uppercase"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item
                label="是否要有小寫英文"
                name="lowercase"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item
                label="是否要有數字"
                name="numbers"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item
                label="是否要有特殊符號"
                name="specialCharacters"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item
                label="密碼長度"
                name="passwordLength"
                rules={[
                { required: true, message: '請輸入密碼長度' },
                { type: 'number', min: 4, max: 20, message: '密碼長度必須在 4 到 20 之間' },
                ]}
            >
                <InputNumber min={4} max={20} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item>
                <Button type="primary" onClick={handleSave} block>
                儲存設定
                </Button>
            </Form.Item>
            </Form>
        </div>
        </div>
    );
};

export default PasswdSetting;
